module.exports = __webpack_public_path__ + "img/254.problem_seller.b106989a.svg";